"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get the module number given a Module
 */
function getModuleNumber({ defaultIndex }) {
    return defaultIndex + 1;
}
exports.default = getModuleNumber;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0TW9kdWxlTnVtYmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2dldE1vZHVsZU51bWJlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBOztHQUVHO0FBQ0gsU0FBd0IsZUFBZSxDQUFDLEVBQUUsWUFBWSxFQUFnQztJQUNwRixPQUFPLFlBQVksR0FBRyxDQUFDLENBQUM7QUFDMUIsQ0FBQztBQUZELGtDQUVDIn0=